import { Injectable, Inject } from '@angular/core';
import { Logger } from '@utils/logger';
import { Subject, Observable } from 'rxjs';
import { WINDOW } from '@ng-web-apis/common';

const logger = Logger.getLogger('OneTrustService');

declare var OnetrustActiveGroups; // global var set by One Trust

export enum OneTrustGroups {
  StrictlyNecessary = 'C0001',
  Performance = 'C0002',
  Functional = 'C0003',
  TargetingGroup = 'BG296',
  Targeting = 'C0004',
  Social = 'C0005',
}

@Injectable({ providedIn: 'root' })
export class OneTrustService {
  oneTrustGroups$: Subject<OneTrustGroups[]> = new Subject();

  constructor(@Inject(WINDOW) readonly windowRef: Window) {
    // Check if 'functional' cookie is not set
    this.getOneTrustGroups().then((groups) => {
      // If groups exist
      if (groups.length > -1) {
        logger.debug('Setting cookies from global OnetrustActiveGroups:');
        logger.debug(groups);
        // if cookie is set send the cookie
        this.oneTrustGroups$.next(groups);
      }

      // Even if groups exist we want to listen for changes
      if (this.windowRef.OneTrust) {
        logger.debug('If OnetrustActiveGroups exist - so will OneTrust');
        this.windowRef.OneTrust?.OnConsentChanged((consent) => {
          logger.debug('OnConsentChanged has been called');
          if (consent.detail?.length > 0) {
            logger.debug('Setting cookies from change event:');
            logger.debug(consent.detail);
            this.oneTrustGroups$.next(consent.detail);
          }
        });
      }
    });
  }

  /**
   * OneTrust creates a global var to check which categories have been consented to.
   * However, it may not have been created by the time the logging is initialized.
   */
  public getOneTrustGroups(): Promise<OneTrustGroups[]> {
    return new Promise((resolve) => {
      if (typeof OnetrustActiveGroups !== 'undefined') {
        resolve(OnetrustActiveGroups.split(','));
      } else {
        const checkVariable = (i = 0) => {
          if (typeof OnetrustActiveGroups !== 'undefined') {
            resolve(OnetrustActiveGroups.split(','));
          } else if (i > 10) {
            resolve([]);
          } else {
            setTimeout(() => checkVariable(i + 1), 100); // retry in a bit
          }
        };
        checkVariable();
      }
    });
  }

  /**
   * Get the above promise as an observable
   */
  public getOneTrustGroups$(): Observable<OneTrustGroups[]> {
    return this.oneTrustGroups$.asObservable();
  }
}
